import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { ActivityArea } from "../../core/model/activity-area";
import { ActivityAreaService } from "../../core/service/activity-area.service";

@Component({
  selector: "app-edit-activity-area",
  templateUrl: "./edit-activity-area.component.html",
  styleUrls: ["./edit-activity-area.component.scss"],
})
export class EditActivityAreaComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;
  loading = true;

  activityAreaId: number;
  activityArea: ActivityArea;

  constructor(
    private _router: Router,
    private _activityAreaService: ActivityAreaService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(20)],
      ],
      label: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(50)],
      ],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.activityAreaId = params["activityAreaId"];
      this.getActivityArea(this.activityAreaId);
    });
  }

  getActivityArea(activityAreaId) {
    this.loading = true;
    this._activityAreaService.getActivityAreaById(activityAreaId).subscribe(
      (data) => {
        this.activityArea = data;
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  save(): void {
    this.pressButton = true;
    this._activityAreaService
      .update(this.activityArea)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/activity-area");
  }
}
